import { getAllFleets } from "../lib/api";

const LANDING_PAGE_PATH = "/landingpage";

/**
 * Determine the redirect path for a newly logged in user based on where they landed
 * when they were not logged in
 *
 */
export const getLoginRedirectPath = (fromLocation) => {
    if (!fromLocation?.pathname) {
        return "/";
    }

    return `${fromLocation.pathname}${fromLocation.search || ''}${fromLocation.hash || ''}`;
};

/**
 * Determine where an authenticated user should land, sending customers without any
 * fleets to the landing page instead of the app
 *
 */
export const resolvePostAuthRedirectPath = async (user, fromLocation) => {
    const redirectPath = getLoginRedirectPath(fromLocation);

    if (user?.userType === "GradientAdmin") {
        return redirectPath;
    }

    const response = await getAllFleets({ pageNumber: 1, pageSize: 25 });

    return response?.data?.zones?.length >= 1 ? redirectPath : LANDING_PAGE_PATH;
};


